import type { Comic, Category, FAQ } from '@/types';

export const categories: Category[] = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-apps-2-line' },
  { id: 'romance', name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 'action', name: '动作', slug: 'action', icon: 'ri-flashlight-line' },
  { id: 'thriller', name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line' },
  { id: 'comedy', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 'drama', name: '剧情', slug: 'drama', icon: 'ri-film-line' },
  { id: 'horror', name: '惊悚', slug: 'horror', icon: 'ri-ghost-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '我的野蛮王妃',
    author: '朴熙珍',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20beautiful%20princess%20in%20elegant%20hanbok%20with%20soft%20pink%20cherry%20blossoms%20in%20background%20clean%20simple%20composition%20warm%20tone%20digital%20art%20style%20minimalist%20background&width=600&height=800&seq=comic-01&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '宫廷', '甜宠'],
    rating: 9.6,
    views: 2850000,
    chapters: 128,
    updateDate: '2026-08-03',
    status: 'ongoing',
    description: '现代少女意外穿越到朝鲜王朝，成为世子妃。在陌生的宫廷中，她与冷酷世子展开了一段啼笑皆非又甜蜜动人的爱情故事。面对宫廷斗争和身份危机，两人携手共度难关。',
    chapterList: [
      { id: 1, title: '第128话 最终抉择', date: '2026-08-03' },
      { id: 2, title: '第127话 内心的声音', date: '2026-07-27' },
      { id: 3, title: '第126话 命运的转折', date: '2026-07-20' },
      { id: 4, title: '第125话 隐藏的真相', date: '2026-07-13' },
      { id: 5, title: '第124话 深夜密谈', date: '2026-07-06' },
      { id: 6, title: '第123话 新的开始', date: '2026-06-29' },
      { id: 7, title: '第122话 重逢之日', date: '2026-06-22' },
      { id: 8, title: '第121话 各自的路', date: '2026-06-15' },
    ],
  },
  {
    id: 2,
    title: '暗夜追踪者',
    author: '金志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20thriller%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20mysterious%20detective%20in%20dark%20city%20alley%20at%20night%20with%20neon%20reflections%20dramatic%20lighting%20clean%20composition%20digital%20art%20style&width=600&height=800&seq=comic-02&orientation=portrait',
    category: 'thriller',
    tags: ['悬疑', '推理', '都市'],
    rating: 9.4,
    views: 1820000,
    chapters: 96,
    updateDate: '2026-08-02',
    status: 'ongoing',
    description: '首尔深夜接连发生离奇案件，天才侧写师韩智浩与刑警队长李秀敏联手追查真相。每一个案件背后都隐藏着不为人知的秘密，而真相远比想象中更加残酷。紧张刺激的悬疑推理漫画。',
    chapterList: [
      { id: 1, title: '第96话 最后的线索', date: '2026-08-02' },
      { id: 2, title: '第95话 迷雾重重', date: '2026-07-26' },
      { id: 3, title: '第94话 关键证人', date: '2026-07-19' },
      { id: 4, title: '第93话 追踪', date: '2026-07-12' },
      { id: 5, title: '第92话 暗流涌动', date: '2026-07-05' },
    ],
  },
  {
    id: 3,
    title: '仙界实习生',
    author: '李恩彩',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20young%20girl%20surrounded%20by%20magical%20elements%20floating%20clouds%20and%20mystical%20glow%20in%20ethereal%20heavenly%20palace%20setting%20soft%20pastel%20colors%20clean%20composition&width=600&height=800&seq=comic-03&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '修仙', '爆笑'],
    rating: 9.5,
    views: 2130000,
    chapters: 112,
    updateDate: '2026-08-01',
    status: 'completed',
    description: '普通大学生一觉醒来竟然成了天庭实习生？在玉皇大帝手下打杂，跟孙悟空做同事，还要应对各路神仙的奇葩要求。一段笑料百出却又温暖人心的仙界冒险。',
    chapterList: [
      { id: 1, title: '第112话 新的开始（完结）', date: '2026-08-01' },
      { id: 2, title: '第111话 最后的考验', date: '2026-07-25' },
      { id: 3, title: '第110话 天庭大乱', date: '2026-07-18' },
    ],
  },
  {
    id: 4,
    title: '格斗天王',
    author: '崔泰浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20action%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20powerful%20fighter%20in%20dynamic%20combat%20pose%20with%20intense%20expression%20fists%20raised%20in%20boxing%20ring%20dramatic%20lighting%20bold%20composition&width=600&height=800&seq=comic-04&orientation=portrait',
    category: 'action',
    tags: ['动作', '热血', '竞技'],
    rating: 9.3,
    views: 1650000,
    chapters: 86,
    updateDate: '2026-07-30',
    status: 'ongoing',
    description: '曾经的格斗冠军因伤退役后沦为街头混混，在一次意外中重拾斗志，重返擂台。面对强大的对手和内心的恐惧，他能否再次登顶格斗之巅？热血澎湃的动作漫画。',
    chapterList: [
      { id: 1, title: '第86话 巅峰对决', date: '2026-07-30' },
      { id: 2, title: '第85话 苦战', date: '2026-07-23' },
      { id: 3, title: '第84话 特训', date: '2026-07-16' },
    ],
  },
  {
    id: 5,
    title: '隔壁的猫咪先生',
    author: '柳秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20comedy%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20cute%20girl%20holding%20a%20fluffy%20cat%20in%20cozy%20apartment%20setting%20with%20warm%20sunlight%20streaming%20through%20window%20soft%20warm%20tones&width=600&height=800&seq=comic-05&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '日常', '暖萌'],
    rating: 9.2,
    views: 1280000,
    chapters: 74,
    updateDate: '2026-08-03',
    status: 'ongoing',
    description: '独居女孩美琳的隔壁搬来了一位神秘的英俊男子，而他竟然可以变成一只猫？一段关于暗恋、秘密和治愈的浪漫故事，温暖你每一个孤独的夜晚。',
    chapterList: [
      { id: 1, title: '第74话 坦白', date: '2026-08-03' },
      { id: 2, title: '第73话 月光下的约定', date: '2026-07-27' },
      { id: 3, title: '第72话 他的秘密', date: '2026-07-20' },
    ],
  },
  {
    id: 6,
    title: '末日生存手册',
    author: '姜东元',
    cover: 'https://readdy.ai/api/search-image?query=A%20post-apocalyptic%20Korean%20manhwa%20cover%20style%20illustration%20of%20survivors%20in%20ruined%20cityscape%20with%20dark%20moody%20atmosphere%20survival%20gear%20and%20determined%20expression%20dramatic%20composition%20dark%20tone&width=600&height=800&seq=comic-06&orientation=portrait',
    category: 'horror',
    tags: ['惊悚', '生存', '末世'],
    rating: 9.7,
    views: 3100000,
    chapters: 105,
    updateDate: '2026-08-02',
    status: 'ongoing',
    description: '不明病毒席卷全球，感染者变成了可怕的怪物。一群幸存者在废墟中挣扎求生，他们不仅要面对怪物的威胁，更要提防人性的黑暗。令人窒息的末日生存漫画。',
    chapterList: [
      { id: 1, title: '第105话 希望的曙光', date: '2026-08-02' },
      { id: 2, title: '第104话 绝地反击', date: '2026-07-26' },
      { id: 3, title: '第103话 牺牲', date: '2026-07-19' },
    ],
  },
  {
    id: 7,
    title: '厨神之路',
    author: '金美英',
    cover: 'https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20young%20chef%20presenting%20beautiful%20dish%20in%20warm%20kitchen%20with%20steam%20rising%20golden%20lighting%20appetizing%20food%20composition&width=600&height=800&seq=comic-07&orientation=portrait',
    category: 'drama',
    tags: ['剧情', '美食', '励志'],
    rating: 9.1,
    views: 980000,
    chapters: 68,
    updateDate: '2026-07-29',
    status: 'ongoing',
    description: '从小在路边摊长大的少年，怀揣着成为顶级厨师的梦想来到首尔。在竞争激烈的料理界，他凭借对食物的热爱和执着，一步步走向厨神之路。让味蕾和心灵都得到满足的美食漫画。',
    chapterList: [
      { id: 1, title: '第68话 传承的味道', date: '2026-07-29' },
      { id: 2, title: '第67话 神秘食材', date: '2026-07-22' },
      { id: 3, title: '第66话 师徒对决', date: '2026-07-15' },
    ],
  },
  {
    id: 8,
    title: '爆笑校园日记',
    author: '张惠珍',
    cover: 'https://readdy.ai/api/search-image?query=A%20comedy%20Korean%20manhwa%20cover%20style%20illustration%20of%20funny%20high%20school%20students%20in%20classroom%20with%20exaggerated%20expressions%20bright%20colorful%20style%20humorous%20scene%20clean%20composition&width=600&height=800&seq=comic-08&orientation=portrait',
    category: 'comedy',
    tags: ['搞笑', '校园', '日常'],
    rating: 9.0,
    views: 1420000,
    chapters: 92,
    updateDate: '2026-08-01',
    status: 'ongoing',
    description: '平凡高中生小明的爆笑校园生活！考试、暗恋、食堂抢饭、体育课出糗……每一个场景都让你笑到肚子痛。献给所有怀念校园时光的你。',
    chapterList: [
      { id: 1, title: '第92话 运动会大作战', date: '2026-08-01' },
      { id: 2, title: '第91话 突击测验', date: '2026-07-25' },
      { id: 3, title: '第90话 食堂新菜单', date: '2026-07-18' },
    ],
  },
  {
    id: 9,
    title: '月光下的约定',
    author: '尹智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20drama%20Korean%20manhwa%20cover%20style%20illustration%20of%20two%20lovers%20under%20moonlight%20in%20traditional%20Korean%20garden%20with%20lanterns%20soft%20silver%20moonlight%20romantic%20atmosphere%20elegant%20composition&width=600&height=800&seq=comic-09&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '古风', '虐心'],
    rating: 9.8,
    views: 3580000,
    chapters: 140,
    updateDate: '2026-08-04',
    status: 'ongoing',
    description: '朝鲜时代，两班贵族之女与平民画师的凄美爱情故事。在阶级森严的社会中，两人许下月光下的约定，却不知命运早已为他们布下了重重考验。被称为年度最虐心韩漫。',
    chapterList: [
      { id: 1, title: '第140话 月光依旧', date: '2026-08-04' },
      { id: 2, title: '第139话 最后的画', date: '2026-07-28' },
      { id: 3, title: '第138话 逃亡', date: '2026-07-21' },
    ],
  },
  {
    id: 10,
    title: '电竞之王',
    author: '朴俊亨',
    cover: 'https://readdy.ai/api/search-image?query=A%20sports%20esports%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20pro%20gamer%20in%20gaming%20arena%20with%20dramatic%20stage%20lighting%20intense%20focus%20surrounded%20by%20screens%20bold%20dynamic%20composition&width=600&height=800&seq=comic-10&orientation=portrait',
    category: 'action',
    tags: ['动作', '电竞', '热血'],
    rating: 9.5,
    views: 2760000,
    chapters: 118,
    updateDate: '2026-08-02',
    status: 'ongoing',
    description: '天才游戏少年被发掘进入职业电竞圈，从网吧少年到世界冠军的传奇之路。极限操作、团队配合、赛场博弈——这是属于电竞时代的热血故事。',
    chapterList: [
      { id: 1, title: '第118话 世界之巅', date: '2026-08-02' },
      { id: 2, title: '第117话 决胜局', date: '2026-07-26' },
      { id: 3, title: '第116话 逆风翻盘', date: '2026-07-19' },
    ],
  },
  {
    id: 11,
    title: '魔女的条件',
    author: '韩素英',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20romance%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20mysterious%20witch%20with%20long%20dark%20hair%20in%20magical%20forest%20with%20glowing%20butterflies%20and%20mystical%20plants%20dark%20elegant%20atmosphere&width=600&height=800&seq=comic-11&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '恋爱', '魔法'],
    rating: 9.3,
    views: 1920000,
    chapters: 88,
    updateDate: '2026-07-31',
    status: 'ongoing',
    description: '普通人类少年意外唤醒了沉睡千年的魔女，两人签订契约开始了一段奇幻冒险。在魔法与现实的交错中，一段跨越种族的爱情悄然萌芽。',
    chapterList: [
      { id: 1, title: '第88话 古老的诅咒', date: '2026-07-31' },
      { id: 2, title: '第87话 魔女之泪', date: '2026-07-24' },
    ],
  },
  {
    id: 12,
    title: '秘密花园',
    author: '郑多恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20drama%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20woman%20in%20mysterious%20garden%20with%20hidden%20secrets%20overgrown%20flowers%20old%20mansion%20in%20background%20dreamy%20slightly%20dark%20atmosphere&width=600&height=800&seq=comic-12&orientation=portrait',
    category: 'thriller',
    tags: ['悬疑', '心理', '都市'],
    rating: 9.6,
    views: 2340000,
    chapters: 102,
    updateDate: '2026-08-03',
    status: 'ongoing',
    description: '搬进神秘老宅的年轻女子发现了一个被荒废的美丽花园，而花园中隐藏着前主人的惊人秘密。每一朵花都藏着一个故事，每一个故事都令人毛骨悚然。',
    chapterList: [
      { id: 1, title: '第102话 花园的尽头', date: '2026-08-03' },
      { id: 2, title: '第101话 最后的花语', date: '2026-07-27' },
    ],
  },
];

export const trendingComics = comics.slice(0, 6);
export const latestUpdates = [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime());

export const siteInfo = {
  name: '韩漫屋',
  tagline: '韩漫在线阅读平台',
  description: '韩漫屋为您提供免费韩国漫画大全，所有无删减下拉式韩漫保证内容的原始风貌。在韩漫屋体验舒适的韩漫在线阅读。',
  keywords: '韩漫屋,韩漫在线阅读,免费韩国漫画大全,无删减,下拉式韩漫',
  url: 'https://www.hanmanwu.com',
  foundingYear: '2020',
  email: 'contact@hanmanwu.com',
  address: '北京市朝阳区望京SOHO T1-1208',
  phone: '400-888-6688',
};

export const faqs: FAQ[] = [
  {
    question: '韩漫屋的漫画都是免费阅读的吗？',
    answer: '是的，韩漫屋平台上所有韩国漫画均为免费在线阅读，无需付费订阅。我们坚持为用户提供无删减、原汁原味的韩漫阅读体验，让每一位韩漫爱好者都能畅享阅读乐趣。',
  },
  {
    question: '韩漫屋的漫画更新频率是怎样的？',
    answer: '韩漫屋与韩国多家漫画平台保持同步更新，热门连载漫画通常每周更新1-2话。您可以在每部漫画的详情页查看具体的更新时间和章节列表，确保不错过任何精彩内容。',
  },
  {
    question: '什么是下拉式韩漫？阅读体验如何？',
    answer: '下拉式韩漫是韩国漫画特有的阅读形式，采用垂直滚动设计，只需向下滑动即可连续阅读，无需翻页。这种阅读方式特别适合手机端浏览，画面衔接流畅自然，阅读体验沉浸舒适。',
  },
  {
    question: '韩漫屋的漫画是否支持下载离线阅读？',
    answer: '目前韩漫屋专注于在线即时阅读体验，暂不支持下载功能。但我们的阅读器已针对移动设备进行全面优化，即使在网络条件一般的情况下也能流畅加载和阅读。',
  },
  {
    question: '如何在韩漫屋找到我想看的漫画？',
    answer: '您可以通过首页的热门推荐、最新更新快速发现精彩漫画，也可以使用分类页面按类型（恋爱、奇幻、动作、悬疑等）进行筛选浏览。我们的搜索功能也在持续优化中，敬请期待。',
  },
  {
    question: '韩漫屋支持哪些设备阅读？',
    answer: '韩漫屋采用响应式设计，完美支持电脑、平板和手机等各类设备。无论您使用什么设备，都能获得适配的阅读界面和流畅的浏览体验。',
  },
];